'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingCells;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _columns = require('../helpers/columns');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var widths = ['40%', '60%', '70%', '85%', '95%'];

function getRandomWidth() {
  return widths[Math.floor(Math.random() * widths.length)];
}

function LoadingCells(_ref) {
  var value = _ref.value,
      columns = _ref.columns;

  if (value > 0) {
    return Array(value).fill().map(function (item, index) {
      var key = 'loading-cell-' + index;
      var type = columns[index].type;
      var isActionOrSelectable = type === _columns.SELECTABLE_CHECKBOX || type === 'action';
      var styles = {
        width: isActionOrSelectable ? '100%' : getRandomWidth()
      };
      return _react2.default.createElement('td', {
        key: key
      }, _react2.default.createElement('div', {
        className: 'rainbow-table_body--loading'
      }, _react2.default.createElement('div', {
        className: 'rainbow-table_body-element--loading',
        style: styles
      })));
    });
  }

  return null;
}

LoadingCells.propTypes = {
  value: _propTypes2.default.number,
  columns: _propTypes2.default.array
};
LoadingCells.defaultProps = {
  value: 0,
  columns: []
};